import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class MwTextarea extends Component {

  @tracked emptyText = '';
  @tracked activeText = 'Introduce yourself...';
  @tracked filledText = 'Hello, world!';
  @tracked disabledText = 'This textarea is disabled';
}
